<template>
   <div class="modal-container ">
        <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ $t(`CRMSetting.AllAttribute`) }}</h4>
                    <a class="modal-close" @click="$emit('closeOrOpen', false)"><i class="fa fa-times"></i></a>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="filter-panel mb-0 pb-0 border-0" v-if="from == 'list'">
                            <div class="listing-option row">
                                <div class="col-xl-5 col-lg-12">
                                    <div class="row">
                                        <div class="form-group col-sm-6 col-md-5 col-lg-5 mb-0 mt-2 mt-lg-0">
                                        </div>
                                        <div class="form-group col-sm-6 col-md-7 col-lg-7 mb-0 mt-2 mt-lg-0">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-7 col-lg-12">
                                    <div class="d-flex flex-wrap justify-content-start justify-content-xl-end mt-md-3 mt-xl-0"
                                        style="margin-bottom: 5px;">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DataTable @sort="onSort($event)" :value="data" stripedRows class="p-datatable-gridlines attribute-list-table"
                            :scrollable="true" scrollHeight="700px" @rowSelect="onRowSelect" :lazy="true"
                            v-model:selection="selectedAssetCategoryAttribute" dataKey="Id">
                            <Column :sortable="true" v-for="col of displaySchema" :field="col.COLUMN_NAME"
                                :header="$filters.dynamicTranslate($t(`CRMSetting.Attribute${col.COLUMN_NAME}`), `CRMSetting.Attribute${col.COLUMN_NAME}`, col.DISPLAY_NAME)"
                                :key="col.Id"
                                :class="getAttributeColumnClass(col)">
                                <template #body="action">
                                    <span v-if="col.COLUMN_NAME == 'Name'">
                                        <a href="Javascript:void(0);"
                                            v-if="filters.IsNull(modulePermission) !== null && modulePermission.roleModuleUpdateFlag && ((action.data.OwnedBy == 'CompanyOwned') || ((action.data.OwnedBy == 'SuperCompanyOwned')))"
                                            v-bind:attribute-id="action.data.Id">{{ action.data[col.COLUMN_NAME] }}</a>
                                        <a href="Javascript:void(0);" v-else="" style="cursor: not-allowed;"
                                            v-bind:attribute-id="action.data.Id">{{
                                                action.data[col.COLUMN_NAME] }}</a>
                                    </span>

                                    <span v-if="col.COLUMN_NAME == 'IsMandatory'">
                                        <span v-if="action.data[col.COLUMN_NAME] == false"
                                            :title="$t('CRMSetting.NoLabel')">{{ $t('CRMSetting.NoLabel') }}</span>
                                        <span v-if="action.data[col.COLUMN_NAME] == true"
                                            :title="$t('CRMSetting.YesLabel')">{{ $t('CRMSetting.YesLabel') }}</span>
                                    </span>
                                    <span v-if="col.COLUMN_NAME == 'IsActive'" class="w-100">
                                        <a v-if="(action.data[col.COLUMN_NAME] == true) && (filters.IsNull(modulePermission) !== null && modulePermission.roleModuleUpdateFlag) && ((action.data.OwnedBy == 'CompanyOwned') || ((action.data.OwnedBy == 'SuperCompanyOwned')))"
                                            href="javascript:;" class="w-100 mx-1">
                                            <span class="label label-light color-3"
                                                :title="$t('CRMSetting.ClickToInActiveLabel')">{{
                                                    $t('CRMSetting.ActiveLabel') }}</span>
                                        </a>

                                        <a v-if="(action.data[col.COLUMN_NAME] == false) && (filters.IsNull(modulePermission) !== null && modulePermission.roleModuleUpdateFlag) && ((action.data.OwnedBy == 'CompanyOwned') || ((action.data.OwnedBy == 'SuperCompanyOwned')))"
                                            href="javascript:;" class="w-100 mx-1">
                                            <span class="label label-light color-5"
                                                :title="$t('CRMSetting.ClickToActiveLabel')">{{
                                                    $t('CRMSetting.InActiveLabel') }}</span>
                                        </a>
                                        <a v-if="(action.data[col.COLUMN_NAME] == false) && (filters.IsNull(modulePermission) !== null && !modulePermission.roleModuleUpdateFlag && modulePermission.roleModuleReadFlag) && ((action.data.OwnedBy == 'CompanyOwned') || ((action.data.OwnedBy == 'SuperCompanyOwned')))"
                                            href="javascript:;" style="cursor: not-allowed;" class="w-100 mx-1">
                                            <span class="label label-light color-5"
                                                :title="$t('CRMSetting.ClickToActiveLabel')">{{
                                                    $t('CRMSetting.InActiveLabel') }}</span>
                                        </a>
                                    </span>
                                    <span
                                        v-if="col.COLUMN_NAME != 'ImagePath' && col.COLUMN_NAME != 'IsActive' && col.COLUMN_NAME != 'Name' && col.COLUMN_NAME != 'IsMandatory'">
                                        {{ action.data[col.COLUMN_NAME] }}
                                    </span>
                                </template>
                            </Column>
                            <template #footer>
                                <div class="row">
                                    <Paginator :template="paginatorTemplate.value" :rows="pageSize"
                                        :totalRecords="totalRecords" :rowsPerPageOptions="pageSizeList"
                                        @page="onPage($event)">
                                        <template #start>
                                            <div class="row">
                                                {{ $t('CRMSetting.TotalRecord') }}: {{ totalRecords }} {{RowsPerPageDropdown }}
                                            </div>
                                        </template>

                                    </Paginator>
                                </div>
                            </template>
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import { createConfirmDialog } from "vuejs-confirm-dialog";
import SimpleDialog from "@/views/shared/SimpleDialog.vue";
import { createToaster } from "@meforma/vue-toaster";
import * as Yup from 'yup';
//Services
import common from '@/views/shared/common/commonuses.js'
import AssetCategoryService from "@/service/crmservice/assetcategoryservice";
import addeditassetcategoryattribute from '../assetcategoryattribute/addeditassetcategoryattribute.vue'
import CommonService from '@/service/crmservice/commonService'

export default {
    name: 'assetAttributelistshared',
    props: {
        assetCategoryId: Yup.string,
        hiddenUiColumns: {
            type: Array,
            default: () => [],
        },
    },
    components: {

        addeditassetcategoryattribute
    },
    setup(props) {
        const addeditassetcategoryattributeref = ref(false);
        const thisApp = getCurrentInstance();
        const filters = thisApp.appContext.config.globalProperties.$filters;
        const paginatorTemplate = filters.PaginatorTemplate(0, 10);
        const toaster = createToaster({ position: 'top-right' });
        const selectedAssetCategoryAttribute = ref([]);
        const deleteObj = ref({});
        const commonuse = ref(common);
        const deleteIds = ref('');
        const isLoading = ref(false);
        const primarykey = ref(null)
        const assetCategoryId = ref(props.assetCategoryId)
        const schema = ref([]);
        const data = ref([]);
        const assetCategoryService = ref(new AssetCategoryService());
        const totalRecords = ref(0);
        const commonService = ref(new CommonService());
        const userId = ref(null);
        const companyId = ref(null);
        const nameSearch = ref(null);
        const searchText = ref(null);
        const pageSize = ref(10);
        const pageNumber = ref(1);
        const pageSizeList = ref([]);
        const sortBy = ref('desc');
        const sortExp = ref('CreatedOn');
        const modulePermission = ref(null);
        const moduleNameCode = ref('6002');
        const submoduleNameCode = ref('6002');
        const customViewId = ref(null);
        const userType = ref(null);
        const pageType = ref('');

        const isAttributeColumnVisible = (columnName) => !props.hiddenUiColumns.includes(columnName);

        const applyAttributeSchemaFilters = (listingSchema) => {
            return listingSchema.filter(
                (column) => column.COLUMN_NAME != 'CreatedOn' && isAttributeColumnVisible(column.COLUMN_NAME)
            );
        };

        const displaySchema = computed(() => schema.value.filter((col) => isAttributeColumnVisible(col.COLUMN_NAME)));

        const getAttributeColumnClass = (col) => {
            if (col.COLUMN_NAME === 'IsActive' || col.COLUMN_NAME === 'IsMandatory') {
                return 'justify-content-center text-center min-max-width-150';
            }
            if (col.COLUMN_NAME === 'Name') {
                return 'min-max-width-280';
            }
            return 'min-max-width-220';
        };

        const GetPageSizeList = () => {
            commonService.value.GetPageSizeList().then(response => {
                if (response.data != null) {
                    pageSizeList.value = response.data.map(item => { return parseInt(item.text) });
                }
            }).catch((error) => {
            });
        }

        const onRowSelect = (rowData) => {
            if (rowData.data) {
                if (rowData.data.OwnedBy && rowData.data.OwnedBy == "CompanyOwned" && userType.value != "usertype01") {

                } else if (userType.value != "usertype01") {
                    selectedAssetCategoryAttribute.value = selectedAssetCategoryAttribute.value.filter(x => x.Id != rowData.data.Id);
                }
            }
        }
        const showassetcategoryattributeModal = (id) => {
            debugger;
            addeditassetcategoryattributeref.value.show(id);
        }
        const updateFilter = (event) => {
            let keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode === 13 || keycode === '13') {
                search();
            }
        }
        const search = async () => {
            pageNumber.value = 1;
            setSearchFilter();
            getAttributeListing();
        }
        const reset = async () => {
            searchText.value = null;
            nameSearch.value = null;
            pageSize.value = 10;
            pageNumber.value = 1;
            getAttributeListing();
        }
        const setSearchFilter = () => {
            nameSearch.value = "Name Like '%" + searchText.value + "%'";
        }
        const onSort = (event) => {
            sortExp.value = event.sortField;
            if (event.sortField == 'IsActive') {
                sortBy.value = event.sortOrder == '1' ? 'desc' : 'asc';
            } else {
                sortBy.value = event.sortOrder == '1' ? 'asc' : 'desc';
            }
            getAttributeListing();
        }

        const onPage = (event) => {
            pageNumber.value = event.page == 0 ? 1 : event.page + 1;
            pageSize.value = event.rows;
            getAttributeListing();
        }


        const getUserInfo = () => {
            userId.value = localStorage.getItem("userId");
            companyId.value = localStorage.getItem("companyId");
        }
        const navigate = (id) => {
            primarykey.value = id;
            showassetcategoryattributeModal(id)
        }

        const getAttributeListing = async () => {
            isLoading.value = true;
            await assetCategoryService.value.getAttributeListing({
                RefId: assetCategoryId.value, nameSearch: nameSearch.value, sortColumn: sortExp.value, sortDir: sortBy.value, pageIndex: pageNumber.value,
                pageSize: pageSize.value, userId: userId.value, companyId: companyId.value, moduleNameCode: moduleNameCode.value, submoduleNameCode: submoduleNameCode.value, customViewId: customViewId.value,
            }).then(response => {
                if (response.data.result) {
                    let result = JSON.parse(response.data.result);
                    console.log("result", result);
                    result.Schema = result.Schema.filter(x => x.COLUMN_NAME != 'OwnedBy');
                    schema.value = applyAttributeSchemaFilters(result.Schema);
                    if (schema.value) {
                        schema.value.forEach(p => {
                            if (p.COLUMN_NAME == 'IsActive') {
                                p.DISPLAY_NAME = 'Status'
                            }
                        })
                    }
                    data.value = result.Data;
                    console.log("data.value", data.value);
                    if (result.Data.length > 0) {
                        totalRecords.value = result.Data[0].total_records;
                    } else {
                        totalRecords.value = 0;
                    }
                    paginatorTemplate.value = filters.PaginatorTemplate(totalRecords.value, pageSize.value)
                    isLoading.value = false;
                }
                isLoading.value = false;
            });
        }
        const deleteCategoryAttribute = (event) => {
            console.log(event);
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                question: `Are you sure you want to delete attribute "${event.Name}"?`,
                header: `Delete Attribute`,
                cancel: `Cancel`,
                confirm: `Ok`,
            });
            onConfirm(async () => {
                isLoading.value = true;
                selectedAssetCategoryAttribute.value = [];
                selectedAssetCategoryAttribute.value.push(event);
                deleteObj.value = {
                    companyId: companyId.value,
                    userId: userId.value,
                    primaryKeys: selectedAssetCategoryAttribute.value
                }
                await assetCategoryService.value.deleteCategoryAttribute(deleteObj.value).then(r => {
                    toaster.success(`Attribute "${event.Name}" has been deleted successfully`);
                    getAttributeListing();
                    isLoading.value = false;
                }, error => {
                    getAttributeListing();
                    //console.warn(error);
                    toaster.error('Something went wrong. Please contact administrator.');
                    isLoading.value = false;
                });
            });
            reveal(() => {
                console.log("reveal")
            });
        }
        const deleteMultipleAssetCategoryAttribute = () => {
            if (selectedAssetCategoryAttribute.value.length > 0) {
                const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                    question: `Are you sure you want to delete selected attribute(s)?`,
                    header: `Delete Attribute(s)`,
                    cancel: `Cancel`,
                    confirm: `Ok`,
                });
                onConfirm(async () => {
                    isLoading.value = true;
                    deleteObj.value = {
                        companyId: companyId.value,
                        userId: userId.value,
                        primaryKeys: selectedAssetCategoryAttribute.value
                    }
                    //deleteIds.value = selectedAssetCategoryAttribute.value.map(x => x.Id).join(',');
                    await assetCategoryService.value.deleteCategoryAttribute(deleteObj.value).then(r => {
                        toaster.success(`Selected Attribute(s) has been deleted successfully`);
                        getAttributeListing();
                        isLoading.value = false;
                    }, error => {
                        getAttributeListing();
                        console.warn(error);
                        toaster.error('Something went wrong. Please contact administrator.');
                        isLoading.value = false;
                    });
                });
                reveal(() => {
                    console.log("reveal")
                });
            } else {
                toaster.error('Please select at least one attribute before delete');
            }

        }
        const getModulePermissions = () => {
            // modulePermission.value = commonuse.value.getPermission(moduleNameCode.value);
            modulePermission.value = commonuse.value.getPermission('6001');
            userType.value = JSON.parse(localStorage.getItem("userinfo")).data.userType;
        }




        const enable = (data) => {
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                question: `Are you sure you want to active Attribute  "${data.Name}"?`,
                header: `Active Attribute`,
                cancel: `Cancel`,
                confirm: `Ok`,
            });
            onConfirm(() => {
                if (data.IsActive == false) {
                    data.IsActive = true;
                } else { data.IsActive = false; }
                isLoading.value = true;
                assetCategoryService.value.ActiveInactiveAssetCategoryAttribute(data.Id, data.IsActive, userId.value, companyId.value).then(r => {
                    toaster.success(`Attribute "${data.Name}" has been activated successfully.`);
                    getAttributeListing();
                    isLoading.value = false;
                }, error => {
                    getAttributeListing();
                    toaster.error('Something went wrong. Please contact administrator.');
                    isLoading.value = false;
                });
            });
            reveal(() => {
                getAttributeListing();
            });
        }

        const disable = (data) => {
            const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                question: `Are you sure you want to in-active attribute  "${data.Name}"?`,
                header: `In-Active Attribute`,
                cancel: `Cancel`,
                confirm: `Ok`,
            });
            onConfirm(() => {
                if (data.IsActive == false) {
                    data.IsActive = true;
                } else { data.IsActive = false; }
                isLoading.value = true;
                assetCategoryService.value.ActiveInactiveAssetCategoryAttribute(data.Id, data.IsActive, userId.value, companyId.value).then(r => {
                    toaster.success(`Attribute "${data.Name}" has been in-activated successfully.`);
                    getAttributeListing();
                    isLoading.value = false;
                }, error => {
                    getAttributeListing();
                    console.warn(error);
                    toaster.error('Something went wrong. Please contact administrator.');
                    isLoading.value = false;
                }

                );

            });
            reveal(() => {
                getAttributeListing();
                //this.isLoding = false;
            });
        }
        onMounted(() => {
            getUserInfo();
            getModulePermissions();
            GetPageSizeList();
            getAttributeListing();
        });

        return {
            primarykey,
            assetCategoryId,
            addeditassetcategoryattributeref,
            schema,
            displaySchema,
            getAttributeColumnClass,
            data,
            assetCategoryService,
            pageSize,
            pageNumber,
            pageSizeList,
            sortBy,
            sortExp, paginatorTemplate, filters,
            totalRecords, selectedAssetCategoryAttribute, modulePermission, userType,
            searchText, updateFilter, deleteMultipleAssetCategoryAttribute,
            showassetcategoryattributeModal,
            search, reset,
            getAttributeListing, deleteCategoryAttribute, onSort, onPage,
            assetCategoryService, isLoading,
            getAttributeListing, deleteCategoryAttribute, navigate, disable, enable, onRowSelect
        }

    }
}
</script>
<style scoped>
.attribute-list-table :deep(.p-datatable-table) {
    table-layout: auto;
    width: 100%;
}

.attribute-list-table :deep(.p-datatable-thead > tr > th),
.attribute-list-table :deep(.p-datatable-tbody > tr > td) {
    white-space: normal;
    word-break: break-word;
}
</style>